<script>
    import Bus from '@/libs/bus';
    import Config from '@/config';
    import {mapActions} from 'vuex';
    import Main from '@/mixins/main';
    import Size from '@/mixins/size';
    import Bubble from '@/libs/bubble';
    import Wave from '@/components/Wave';
    import {Button, PullRefresh, Toast} from 'vant';
    import {stopChargeByGunCode, getCost, replyState} from '@/api';
    import {randomIntFromRange, getWebsocketUrl} from '@/libs/util';

    export default {
        mixins: [
            Main,
            Size
        ],
        components: {
            Wave,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh
        },
        props: {
            snParam: {
                type: String,
                required: true
            },
            gunCodeParam: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                // 32位订单号
                sn: null,
                // 18位枪编号
                gunCode: null,
                /////////////////////
                // 充电状态值
                chargeVoltage: '0.0',
                chargeCurrent: '0.0',
                chargeKWh: '0.00',
                seconds: 0,
                money: '0.00',
                soc: 0,
                remainsChargeMinutes: 0,
                /////////////////////
                // 按钮触发的请求进行中
                loading: false,
                // 是否显示订单费用详情对话框
                showFee: false,
                // 费用详情
                cost: null,
                // 充电动画
                canvas: null,
                ctx: null,
                width: null,
                height: null,
                // 动画气泡
                timer: 0,
                bubbles: [],
                spawnRate: 1,
                // 动画id，停止动画需要
                animationFrameId: null,
                /////////////////////
                stopTimeout: null,
                connectTimeout: null,
                buttonText: '停止充电',
                // 等待订单倒计时
                waitOrderTip: '',
                waitOrderTimeout: null,

                refreshing: false
            };
        },
        computed: {
            chargeTime() {
                return Math.ceil(this.seconds / 60);
            }
        },
        watch: {
            $route(to) {
                if (to.name === 'charge') {
                    this.sn = to.query.snParam;
                    this.gunCode = to.query.gunCodeParam;
                }
            },
            charging(value, oldValue) {
                if (!value && oldValue) {
                    // 停止充电
                    window.document.title = '充电结束';
                    this.stopAnimation();

                    getCost(this.sn).then(response => {
                        this.cost = {
                            tipRate: response.data.body.tipRate.toFixed(4),
                            valleyRate: response.data.body.valleyRate.toFixed(4),
                            flatRate: response.data.body.flatRate.toFixed(4),
                            peakRate: response.data.body.peakRate.toFixed(4),
                            serviceRate: response.data.body.serviceRate.toFixed(4),

                            tipKwh: response.data.body.tipKwh.toFixed(2),
                            valleyKwh: response.data.body.valleyKwh.toFixed(2),
                            flatKwh: response.data.body.flatKwh.toFixed(2),
                            peakKwh: response.data.body.peakKwh.toFixed(2),

                            tipAmount: response.data.body.tipAmount.toFixed(2),
                            valleyAmount: response.data.body.valleyAmount.toFixed(2),
                            flatAmount: response.data.body.flatAmount.toFixed(2),
                            peakAmount: response.data.body.peakAmount.toFixed(2),
                            serviceAmount: response.data.body.serviceAmount.toFixed(2),

                            endSoc: response.data.body.endSoc,
                            kwh: response.data.body.kwh.toFixed(2),
                            amount: response.data.body.amount.toFixed(2),
                            actualAmount: response.data.body.actualAmount.toFixed(2)
                        };

                        this.chargeVoltage = '0.0';
                        this.chargeCurrent = '0.0';
                        this.chargeKWh = response.data.body.kwh.toFixed(2);
                        this.seconds = response.data.body.durationSeconds;
                        this.money = response.data.body.amount.toFixed(2);
                        this.soc = response.data.body.endSoc;
                        this.drawMeter(this.soc, 100);
                        this.cleanWaitOrder();
                    });
                } else if (value && !oldValue) {
                    this.startAnimation();
                    this.cleanConnectionStatus();
                    window.document.title = '正在充电';
                }
            }
        },
        mounted() {
            this.sn = this.snParam;
            this.gunCode = this.gunCodeParam;

            this.init();

            this.connectionStatus();

            this.getChargingOrder();

            this.$connect(getWebsocketUrl());

            Bus.$on('ORDER', () => {
                // 充电结束，需要发起请求获取费用详情
                this.setCharging(false);
            });

            Bus.$on('WORK', data => {
                this.refreshing = false;

                if (this.showFee) {
                    return;
                }
                // 充电中
                this.setCharging(true);
                this.chargeVoltage = data.voltage.toFixed(1);
                this.chargeCurrent = data.current.toFixed(1);
                this.chargeKWh = data.chargeKwh.toFixed(2);
                this.money = data.totalMoney.toFixed(2);
                this.remainsChargeMinutes = data.remainsChargeMinutes;
                this.seconds = data.chargeSeconds;
                this.soc = data.soc;
            });

            Bus.$on('MSG', data => {
                // 显示服务器发来的消息
                Toast.success(data);
            });

            // 请求服务器立刻返回充电状态信息
            replyState(this.gunCode.substr(0, 16)).then(response => {
            });
        },
        methods: {
            ...mapActions([
                'sendMessage'
            ]),
            refresh() {
                this.destroyed();
                this.mounted();
            },
            init() {
                this.canvas = this.$refs.canvas;
                this.height = 220;

                this.ctx = this.canvas.getContext('2d');

                this.canvas.width = this.width * window.devicePixelRatio;
                this.canvas.height = this.height * window.devicePixelRatio;
                this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);

                this.renderLoop();
            },
            renderLoop() {
                // 气泡
                if (this.charging) {
                    this.drawBubbles(this.canvas, this.ctx);
                }
                // 进度
                this.drawMeter(this.ctx, this.width / 2, this.height / 2, 64, this.soc, 100);
                //
                if (this.charging) {
                    this.startAnimation();
                }
            },
            startAnimation() {
                this.animationFrameId = window.requestAnimationFrame(this.renderLoop);
            },
            stopAnimation() {
                window.cancelAnimationFrame(this.animationFrameId);
            },
            drawBubbles(canvas, ctx) {
                ctx.fillStyle = '#009251';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                this.bubbles.forEach((bubble, index) => {
                    bubble.update(ctx);
                    if (bubble.y <= 0) {
                        this.bubbles.splice(index, 1);
                    }
                });

                this.timer = this.timer + 1;
                if (this.timer % this.spawnRate === 0) {
                    const radius = randomIntFromRange(4, 16);
                    this.spawnRate = randomIntFromRange(50, 100);
                    this.bubbles.push(new Bubble(Math.max(radius, Math.random() * canvas.width - radius), canvas.height + 100, radius, 'white'));
                }
            },
            drawMeter(ctx, centerX, centerY, radius, value, maxvalue) {
                // 底层圆环
                ctx.beginPath();
                ctx.lineWidth = 2;
                ctx.lineCap = 'round';
                ctx.strokeStyle = 'rgba(255,255,255,0.3)';
                ctx.arc(centerX, centerY, radius, 1.5 * Math.PI, 3.5 * Math.PI, false);
                ctx.stroke();
                ctx.closePath();
                // 进度圆环
                ctx.beginPath();
                ctx.lineJoin = 'round';
                ctx.strokeStyle = 'rgba(255,255,255,1)';
                ctx.arc(centerX, centerY, radius, 1.5 * Math.PI, (value * 2 / maxvalue + 1.5) * Math.PI, false);
                ctx.stroke();
                ctx.closePath();
                // value
                ctx.textAlign = 'center';
                ctx.fillStyle = '#ffffff';
                ctx.font = '500 26px sans-serif';
                ctx.fillText(value + '%', centerX, centerY);
                // soc
                ctx.font = '500 14px sans-serif';
                ctx.fillText('当前电量', centerX, centerY + radius / 2);
                // 起始点
                ctx.save();
                ctx.translate(centerX, centerY);
                ctx.beginPath();
                ctx.lineWidth = 1;
                ctx.fillStyle = '#ffffff';
                ctx.arc(0, -radius, 2, 0, 2 * Math.PI, false);
                ctx.stroke();
                ctx.fill();
                ctx.closePath();
                ctx.restore();
                // 进度圆点
                ctx.save();
                ctx.translate(centerX, centerY);
                ctx.rotate((360 / (maxvalue / value)) * Math.PI / 180);
                ctx.beginPath();
                ctx.arc(0, -radius, 4, 0, 2 * Math.PI, false);
                ctx.stroke();
                ctx.fill();
                ctx.closePath();
                ctx.restore();
            },
            closeFee() {
                this.showFee = false;
                setTimeout(() => this.init(), 500);
            },
            stopCharge() {
                this.loading = true;

                stopChargeByGunCode(this.gunCode).then(response => {
                    if (response.data.code === Config.successCode) {
                        this.waitOrder();
                        this.showFee = true;
                        window.document.title = '正在结束充电';
                    }
                }).finally(() => {
                    this.loading = false;
                });

                this.stopTimeout = setTimeout(() => {
                    if (this.charging) {
                        Toast.fail('停止充电超时，请返回后从新进入该页面');
                    }
                }, 30000);
            },
            cleanConnectionStatus() {
                if (this.stopTimeout) {
                    clearTimeout(this.stopTimeout);
                }
                if (this.connectTimeout) {
                    clearInterval(this.connectTimeout);
                }
                this.buttonText = '停止充电';
            },
            connectionStatus() {
                if (this.charging) {
                    window.document.title = '正在充电';
                    return;
                }

                let seconds = 30;
                window.document.title = '连接中...';
                this.connectTimeout = setInterval(() => {
                    if (seconds >= 0) {
                        this.buttonText = '连接中(' + seconds + 's)';
                        seconds--;
                        return;
                    }

                    this.cleanConnectionStatus();

                    if (!this.charging) {
                        Toast.fail('获取充电状态超时');
                    }
                }, 1000);
            },
            waitOrder() {
                let seconds = 30;
                this.waitOrderTimeout = setInterval(() => {
                    if (seconds >= 0) {
                        this.waitOrderTip = '(' + seconds + 's)';
                        seconds--;
                    } else {
                        this.cleanWaitOrder();
                    }
                }, 1000);
            },
            cleanWaitOrder() {
                this.waitOrderTip = '';
                if (this.waitOrderTimeout) {
                    clearInterval(this.waitOrderTimeout);
                }
            }
        },
        destroyed() {
            // 取消订阅消息
            Bus.$off('ORDER');
            Bus.$off('WORK');
            // 关闭websocket
            this.$disconnect();

            this.cleanConnectionStatus();
        }
    }
</script>

<template>
    <van-pull-refresh v-model="refreshing" @refresh="refresh" id="charging">
        <div class="canvas-container">
            <canvas v-if="!showFee" :style="{width: width + 'px', height: height + 'px'}" type="2d" class="canvas" ref="canvas"/>
        </div>
        <div class="status">
            <div class="column">
                <div class="value">{{chargeVoltage}}伏</div>
                <div class="label">充电电压</div>
            </div>
            <div class="column">
                <div class="value">{{chargeCurrent}}安</div>
                <div class="label">充电电流</div>
            </div>
            <div class="column">
                <div class="value">{{chargeKWh}}度</div>
                <div class="label">充电电量</div>
            </div>
            <div class="column">
                <div class="value">{{chargeTime}}分钟</div>
                <div class="label">充电时间</div>
            </div>
        </div>
        <wave :wave-status="charging"/>
        <div class="money-time">
            <div class="column">
                <div class="value">{{money}}</div>
                <div class="label">充电金额(元)</div>
            </div>
            <div class="h-split-line"></div>
            <div class="column">
                <div class="value">{{remainsChargeMinutes}}</div>
                <div class="label">预计充满(分钟)</div>
            </div>
        </div>
        <div class="stop-button">
            <van-button round block color="#009251" custom-style="box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);" loading-text="停止中..." :disabled="loading || !charging" :loading="loading" @click="stopCharge">{{buttonText}}</van-button>
        </div>
        <div v-if="showFee" class="mask"></div>
        <div v-if="showFee" class="fee">
            <template v-if="cost">
                <div class="circle">
                    <div class="soc">{{cost.endSoc}}%</div>
                    <div class="label">充电电量</div>
                </div>
                <div class="middle">
                    <div class="label">充电结束</div>
                    <div class="money">￥{{cost.amount}}</div>
                    <div class="description">总计金额{{cost.amount === cost.actualAmount ? '' : ' ' + cost.actualAmount}}</div>
                </div>
                <div class="detail">
                    <div class="row label">
                        <div class="item align-left">电价费率</div>
                        <div class="item">时段电量</div>
                        <div class="item">小计</div>
                    </div>
                    <div class="row">
                        <div class="item align-left">{{cost.tipRate}}元/度（尖）</div>
                        <div class="item align-right">{{cost.tipKwh}}度</div>
                        <div class="item align-right">{{cost.tipAmount}}元</div>
                    </div>
                    <div class="row">
                        <div class="item align-left">{{cost.valleyRate}}元/度（峰）</div>
                        <div class="item align-right">{{cost.valleyKwh}}度</div>
                        <div class="item align-right">{{cost.valleyAmount}}元</div>
                    </div>
                    <div class="row">
                        <div class="item align-left">{{cost.flatRate}}元/度（平）</div>
                        <div class="item align-right">{{cost.flatKwh}}度</div>
                        <div class="item align-right">{{cost.flatAmount}}元</div>
                    </div>
                    <div class="row">
                        <div class="item align-left">{{cost.peakRate}}元/度（谷）</div>
                        <div class="item align-right">{{cost.peakKwh}}度</div>
                        <div class="item align-right">{{cost.peakAmount}}元</div>
                    </div>
                    <div class="row label">
                        <div class="item align-left">服务费率</div>
                        <div class="item">充电电量</div>
                        <div class="item">小计</div>
                    </div>
                    <div class="row">
                        <div class="item align-left">{{cost.serviceRate}}元/度</div>
                        <div class="item align-right">{{cost.kwh}}度</div>
                        <div class="item align-right">{{cost.serviceAmount}}元</div>
                    </div>
                </div>
                <div class="ok" @click="closeFee">确定</div>
            </template>
            <template v-else>
                <div class="tip">等待桩停止充电并上传订单{{waitOrderTip}}</div>
            </template>
        </div>
    </van-pull-refresh>
</template>

<style>
    #charging {
        background-color: white;
    }

    #charging .canvas-container {
        background-color: #009251;
    }

    #charging .status {
        color: white;
        display: flex;
        padding: 12px 24px;
        align-items: center;
        background-color: #009251;
        justify-content: space-between;
    }

    #charging .status .column {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    #charging .status .column .value {
        color: #D0F6E5;
        font-size: 16px;
        font-weight: bold;
    }

    #charging .status .column .label {
        color: #A3E7C9;
        font-size: 12px;
        font-weight: 500;
        margin-top: 4px;
    }

    #charging .money-time {
        padding: 36px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    #charging .money-time .column {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    #charging .money-time .column .value {
        color: #333333;
        font-size: 28px;
        font-weight: bold;
        margin-top: 4px;
    }

    #charging .money-time .column .label {
        color: #999999;
        font-size: 14px;
        font-weight: 500;
    }

    #charging .money-time .h-split-line {
        width: 0;
        height: 32px;
        border-left: 1px solid #C2C2C2;
    }

    #charging .stop-button {
        margin: 24px;
    }

    #charging .mask {
        top: 0;
        left: 0;
        z-index: 99;
        width: 100%;
        height: 100%;
        opacity: 0.6;
        position: fixed;
        background-color: #666666;
    }

    #charging .fee {
        top: 64px;
        left: 0;
        right: 0;
        z-index: 999;
        padding: 12px;
        margin: 0 24px;
        position: fixed;
        text-align: center;
        border-radius: 12px;
        background-color: white;
    }

    #charging .fee .tip {
        color: #333333;
        font-size: 14px;
        font-weight: 500;
    }

    #charging .fee .circle {
        top: 20px;
        width: 84px;
        height: 84px;
        position: fixed;
        border-radius: 50%;
        left: calc(50% - 42px);
        border: 6px solid white;
        background-color: #009251;

        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }

    #charging .fee .circle {
        font-weight: 500;
    }

    #charging .fee .circle .soc {
        color: white;
        font-size: 20px;
    }

    #charging .fee .circle .label {
        color: #B9E6D2;
        font-size: 12px;
        margin-top: 4px;
    }

    #charging .fee .middle {
        margin-top: 56px;
    }

    #charging .fee .middle .label {
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }

    #charging .fee .middle .money {
        margin: 12px 0;
        color: #009251;
        font-size: 30px;
        font-weight: bold;
    }

    #charging .fee .middle .description {
        color: #999999;
        font-size: 14px;
        font-weight: 500;
    }

    #charging .fee .detail {
        margin: 12px;
        padding: 12px;
        border-radius: 10px;
        background-color: #F8F8F8;
    }

    #charging .fee .detail .row {
        margin: 4px 0;
        color: #666666;
        font-size: 12px;
        font-weight: 500;

        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    #charging .fee .detail .row.label {
        margin: 8px 0;
        color: #999999;
    }

    #charging .fee .detail .row .item {
        flex: 1;
        text-align: center;
    }

    #charging .fee .detail .row .item.align-left {
        flex: 1.2;
        text-align: left;
    }

    #charging .fee .detail .row .item.align-right {
        flex: 1;
        text-align: right;
    }

    #charging .fee .ok {
        color: white;
        padding: 12px 0;
        border-radius: 20px;
        background-color: #009251;
        margin: 24px 36px 12px 36px;
        box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);
    }
</style>
